<!-- eslint-disable prettier/prettier -->
<template>
  <div class="my-4 gdpr-container">
    <p v-translate>
      Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé par Videomuseum pour la création et la gestion de comptes utilisateurs sur la plateforme Navigart.
    </p>
    <p v-translate>Les données collectées ne seront pas communiquées à des tiers.</p>
    <p v-translate>Les données sont conservées pendant 3 ans à partir de la date de dernière connexion.</p>
    <p v-translate>
      Vous pouvez accéder aux données vous concernant, les rectifier ou demander leur effacement ou exercer votre droit à la limitation du traitement de vos données.
    </p>
    <p v-translate>Consultez le site cnil.fr pour plus d’informations sur vos droits.</p>
    <p v-translate>
      Pour exercer ces droits ou pour toute question sur le traitement de vos données dans ce dispositif, vous pouvez contacter <a href="mailto:info@videomuseum.fr">info@videomuseum.fr</a>.
    </p>
    <p v-translate>
      Si vous estimez, après nous avoir contactés, que vos droits « Informatique et Libertés » ne sont pas respectés, vous pouvez adresser une réclamation à la CNIL.
    </p>
  </div>
</template>

<script>
export default {
  name: 'GDPR',
  components: {},
};
</script>
<style lang="less">
.gdpr-container {
  margin-left: 7rem;
  margin-right: 7rem;
}
</style>
